// extracted by mini-css-extract-plugin
module.exports = {"ugcRec":"index_ugcRec__2yimp","skeleton":"index_skeleton__QDmg_","empty":"index_empty__XGKq7"};